<template>
  <div class="home-page">
    <HomeHero2 />
    <HomeHero />
    <ScrollAbout />
    <OurServices />
    <PdfGuide />
    <AboutUs />
    <CustomersSay />
    <FreshPosts />
    <!-- <transition name="fade-custom2" mode="out-in">
      <router-view />
    </transition> -->
  </div>
</template>

<script>
import HomeHero from "@/components/sections/HomeHero.vue";
import HomeHero2 from "@/components/sections/HomeHero2.vue";
import OurServices from "@/components/sections/OurServices.vue";
import PdfGuide from "@/components/sections/PdfGuide.vue";
import AboutUs from "@/components/sections/AboutUs.vue";
import CustomersSay from "@/components/sections/CustomersSay.vue";
import FreshPosts from "@/components/sections/FreshPosts.vue";
import ScrollAbout from "@/components/ScrollAbout.vue";

export default {
  name: "Home",
  metaInfo: {
    link: [{ rel: "canonical", href: process.env.VUE_APP_SITE_URL }]
  },
  beforeRouteEnter(to, from, next) {
    if (to.hash !== "#kapcsolat") {
      return next();
    }
    setTimeout(() => {
      window.scroll({
        top: document.body.scrollHeight,
        left: 0,
        behavior: "smooth"
      });
    }, 300);
    next();
  },
  components: {
    HomeHero,
    HomeHero2,
    OurServices,
    PdfGuide,
    AboutUs,
    CustomersSay,
    FreshPosts,
    ScrollAbout
  }
};
</script>

<style lang="scss">
.home-page {
  // padding: 26px 0;
  // margin-bottom: 100vh;
  background: $background;
}

.fade-custom2-enter-active,
.fade-custom2-leave-active {
  transition: all 0.5s;
}
.fade-custom2-enter,
.fade-custom2-leave-to {
  opacity: 0;
  transform: translateY(10%);
}
</style>
